/**
 * The sidebar's "Activity · N new" badge: the unread notifications of the person's inbox (mentions, handoff notes,
 * answers to suggestions) plus the sessions of their AI tools that moved since they last opened Activity (`/history`).
 * The last visit is remembered per browser.
 */
const LAST_VISIT_KEY = 'flow.activity.lastVisit';

export function lastActivityVisit() {
  try {
    const value = Number(localStorage.getItem(LAST_VISIT_KEY));
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function markActivityVisited(now = Date.now()) {
  try { localStorage.setItem(LAST_VISIT_KEY, String(now)); } catch { /* not remembered */ }
}

/**
 * How many new things: `inbox` `{ unread, items }` or null, `sessions` the AI tool sessions (`{ end, start }`), `since`
 * the last visit (ms; null: never visited, then the sessions do not count, only the inbox).
 */
export function activityNewCount({ inbox = null, sessions = [], since = null } = {}) {
  const unread = inbox ? (inbox.unread ?? (inbox.items || []).filter((item) => !item.read).length) : 0;
  const moved = since
    ? (sessions || []).filter((session) => {
      const at = new Date(session?.end || session?.start || 0).getTime();
      return Number.isFinite(at) && at > since;
    }).length
    : 0;
  return unread + moved;
}

/** The badge's text: null for nothing, "99+ new" past 99. */
export function activityBadgeText(count) {
  if (!count || count < 1) { return null; }
  return `${count > 99 ? '99+' : count} new`;
}
